var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4302 5.45625C22.446 5.67832 22.446 5.90044 22.446 6.12251C22.446 12.8959 17.2906 20.7005 7.86802 20.7005C4.96509 20.7005 2.26841 19.8598 0 18.4004C0.412451 18.448 0.808984 18.4639 1.2373 18.4639C3.63257 18.4639 5.83755 17.6549 7.59834 16.2748C5.3458 16.2272 3.45811 14.752 2.80771 12.7215C3.125 12.769 3.44224 12.8008 3.77539 12.8008C4.2354 12.8008 4.69546 12.7373 5.12373 12.6263C2.77603 12.1504 1.01519 10.0882 1.01519 7.59775V7.53433C1.69727 7.91504 2.49048 8.15298 3.33115 8.18467C1.95107 7.2646 1.04692 5.69419 1.04692 3.91753C1.04692 2.96577 1.30068 2.09331 1.74487 1.33188C4.26709 4.44102 8.05835 6.47144 12.3096 6.69355C12.2303 6.31284 12.1827 5.91631 12.1827 5.51973C12.1827 2.69609 14.4669 0.395996 17.3064 0.395996C18.7816 0.395996 20.1141 1.01465 21.05 2.01401C22.208 1.79194 23.3184 1.36362 24.302 0.776709C23.9212 1.96646 23.1122 2.96582 22.0494 3.60029C23.0805 3.48931 24.0799 3.20371 24.9999 2.80718C24.302 3.82236 23.4295 4.72651 22.4302 5.45625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cf855fc3495f0fc34f0d1d19de8dc7ff.svg";
export { ForwardRef as ReactComponent };